import { h, Fragment } from "preact";
import classname from "../../foundation/utils/classname";

import "./style.css";

interface Props {
    class?: string;
    tabIndex?: number;
    [rest: string]: unknown;
}

function RadioButton(props: Props) {
    const { class: cssClass, ...inputProps } = props;

    return (
        <>
            {h("input", Object.assign(inputProps, { type: "radio", class: "radioButtonRadio" }))}
            <div class={classname("radioButton", cssClass)}>
                <div class="radioButtonInner"></div>
            </div>
        </>
    );
}

export default RadioButton;
